<template>
  <v-card flat class="px-2">
    <v-data-table :items="items" :search="search" :fixed-header="fixedHeader" :headers="getHeaders()"
      :height="fixedHeader ? table_height : null" :disable-pagination=true no-data-text="No accommodations to display"
      :hide-default-footer="true" :loading="xloading">
      <template v-slot:top>
        <v-text-field v-if="searchfield" v-model="search" prepend-icon="mdi-magnify" label="Search through all fields"
          class="mx-4 searchfield"></v-text-field>
      </template>
      <template v-slot:item="props">
        <tr>
          <td class="image-alignment">
            <div class="image-borders" style="cursor: pointer;">
              <v-img :src="props.item.photo" width="125px" height="100px"
                @click="$router.open('/huis/onHuis/' + props.item.huis_encrid)"></v-img>
            </div>
            <slot name="parkbutton" :param="props.item.huis_encrid" :acco="props.item.huis_code"
              :park="props.item.park_naam" />
          </td>
          <td @click="$router.open('/huis/onHuis/' + props.item.huis_encrid)" class="td-markup">
            <div><a> {{ props.item.huis_code }} </a></div>
            <div class="default-cursor"><span> {{ props.item.bedr_code }} </span><span class="ml-2 mr-2">-</span><span>
                {{ props.item.hstptaal_oms }} </span></div>
            <div class="default-cursor">{{ props.item.cttptaal_oms }} </div>            
          </td>
          <td class="td-markup default-cursor">
            <div style="display: flex; flex-direction: row; align-items:center;">
              <div class="mt-1">{{ props.item.pricing_system }}</div>
              <div v-if="props.item.hasPriorityPrice"><v-avatar :size="18"
                  style="border: solid 2px red; margin-left: 6px;"><v-icon color="red"
                    x-small>mdi-parking</v-icon></v-avatar></div>
            </div>
          </td>
          <td class="td-markup" style="width: 120px;">
            <div class="headline text-center default-cursor"> {{ props.item.stat_code }}
              <span v-if="props.item.hserNumberOfErrors !== ''"><v-avatar size="21" class="mb-1 mr-1 acco-error"> {{
                props.item.hserNumberOfErrors }} </v-avatar></span>
              <span v-if="props.item.hserNumberOfWarnings !== ''"><v-avatar size="21" class="mb-1 acco-warning"> {{
                props.item.hserNumberOfWarnings }} </v-avatar></span>
            </div>
            <div class="text-center default-cursor"><v-icon>mdi-account</v-icon> {{ props.item.huis_aantpers_max }}
            </div>
          </td>
          <td class="td-markup default-cursor">
            <div>{{ props.item.huis_plaats }}</div>
            <div>{{ props.item.huis_naam }}</div>
            <div v-if="props.item.connector !== ''">
              {{ props.item.connector }} - {{ props.item.park_naam }} 
              <div>Connection type: <i>{{props.item.connection_type }}</i></div>
              <div v-if="props.item.connector !== ''" class="tiny">({{ props.item.toname }})</div>
            </div>  
            <div v-else></div>
          </td>
          <td class="td-markup default-cursor">
            <div v-for="contact in props.item.contacts" v-bind:key="contact.eign_code">
          <td><span class="mr-3" @click="$router.open('/eign/onEign/' + contact.eign_encrid)"><a>{{ contact.eign_code
                }}</a></span><span>{{ contact.eign_naam }}</span><span class="ml-2 mr-2">-</span><span>{{
                  contact.hsct_rol }}</span></td>
          </div>
          </td>
          <td class="td-markup default-cursor">
            <div v-for="regel in props.item.planning" v-bind:key="regel.planCode">
          <td>{{ regel.planCode }}</td>
          </div>
          </td>
          <td class="td-markup default-cursor">
            <div v-for="regel in props.item.planning" v-bind:key="regel.planCode">
          <td>{{ regel.planToCode }}</td>
          </div>
          </td>
          <td class="td-markup default-cursor">
            <div>
          <td>Booking.com</td>
          </div>
          <div>
            <td>AirBnb</td>
          </div>
          <div>
            <td>Vrbo</td>
          </div>
          <div>
            <td>Holidu</td>
          </div>
          <div>
            <td>HomeToGo</td>
          </div>
          <div>
            <td>Check24</td>
          </div>
          <div>
            <td><i>Feratel</i></td>
          </div>
          </td>
          <td class="td-markup default-cursor">
            <div>
          <td><span v-if="props.item.booking"><v-icon small color="success">mdi-check-bold</v-icon></span><span
              v-else><v-icon small>mdi-cancel</v-icon></span></td>
          </div>
          <div>
            <td><span v-if="props.item.airbnb"><v-icon small color="success">mdi-check-bold</v-icon></span><span
                v-else><v-icon small>mdi-cancel</v-icon></span></td>
          </div>
          <div>
            <td><span v-if="props.item.vrbo"><v-icon small color="success">mdi-check-bold</v-icon></span><span
                v-else><v-icon small>mdi-cancel</v-icon></span></td>
          </div>
          <div>
            <td><span v-if="props.item.holidu"><v-icon small color="success">mdi-check-bold</v-icon></span><span
                v-else><v-icon small>mdi-cancel</v-icon></span></td>
          </div>
          <div>
            <td>
              <span v-if="props.item.hometogo2 !== 0">
                <v-icon small :class="`htg${props.item.hometogo2}`">mdi-check-bold</v-icon>
              </span>
              <span v-else>
                <v-icon small>mdi-cancel</v-icon>
              </span>
            </td>
          </div>
          <div>
            <td>
              <span v-if="props.item.check24 !== 0">
                <v-icon small :class="`htg${props.item.check24}`">mdi-check-bold</v-icon>
              </span>
              <span v-else>
                <v-icon small>mdi-cancel</v-icon>
              </span>
            </td>
          </div>
          <div>
            <td>
              <span v-if="props.item.feratel_oestat !== '' && props.item.feratel_betriebnr !== ''">

                <v-icon v-if="props.item.feratel_connection_check !== ''" small color="success">mdi-check-bold</v-icon>
                <v-icon v-if="props.item.feratel_connection_check == ''" small color="warning">mdi-check-bold</v-icon>
              </span>
              <span v-else>
                <v-icon small>mdi-cancel</v-icon>
              </span>
            </td>
          </div>
          </td>
        </tr>
      </template>

    </v-data-table>
  </v-card>
</template>

<script>
export default {
  props: {
    items: Array,
    table_height: {
      type: Number,
      default: 700
    },
    fixedHeader: {
      type: Boolean,
      default: true
    },
    searchfield: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    } 
  },
  data() {
    return {
      search: '',
    }
  },
  computed: {
    xloading() {
      return this.loading;
    }
  },
  methods: {
    getColor(v) {
      console.log(v);
      v === 1 ? 'warning' : 'success';
    },
    getHeaders() {
      return [
        { text: "", sortable: false },
        { text: "Accommodation", value: 'searchsethuis', hsortable: false },
        { text: "Pricing", value: 'pricing_system', sortable: false, width: "1%" },
        { text: "State", value: 'stat_code', align: "center", sortable: false },
        { text: "Place/name", value: 'searchsetplace', sortable: false },
        { text: "Contacts", value: 'searchsetcontact', sortable: false },
        { text: "Planning code(s)", value: 'searchsetplan', sortable: false },
        { text: "TO code(s)", value: 'searchsettocode', sortable: false },
        { text: "Partners", sortable: false },
        { text: "", sortable: false, width: "1%" },
      ];
    }
  }
}    
</script>

<style scoped>
.image-borders {
  padding-top: 8px !important;
}

.image-alignment {
  vertical-align: top;
  width: 120px !important;
  /* trick to add padding to a TD element (which is not possible with CSS normally) */
}

.td-markup {
  vertical-align: top;
  border-top: 5px solid transparent;
  /* trick to add padding to a TD element (which is not possible with CSS normally) */
}

.htg1 {
  color: orange !important;
}

.htg2 {
  color: #32B232 !important;
}

.acco-error {
  background: transparent !important;
  font-size: 12px !important;
  font-weight: 600 !important;
  border: 2px solid red;
  color: red;
  cursor: default;
}

.acco-warning {
  background: transparent !important;
  font-size: 12px !important;
  font-weight: 600 !important;
  border: 2px solid orange;
  color: orange;
  cursor: default;
}

.default-cursor {
  cursor: default;
}

.tiny {
  font-size: 8pt !important;
  font-weight: 300 !important;
  color: black !important;
}

.searchfield {
  width: 25% !important;
}
</style>